import React, { useState, useEffect } from 'react'
import { string, func } from 'prop-types'
import classNames from 'classnames'
import { productsDataType } from 'models/propTypes'
import { useTranslation } from 'react-i18next'
import * as modes from 'models/ui/constants'
import ProductDetailsViewContainer from 'containers/designSidepanel/ProductDetailsViewContainer'
import { MY_ITEMS_BROWSE_NUM_COLUMNS } from 'models/ui/constants'
import Products from 'components/designSidepanel/Products'

require('./MyItemsBrowseView.scss')

const FavoritesBrowseView = ({ products, mode, addAllToBag }) => {
    const { t } = useTranslation()
    const isDetailsVisible = mode === modes.DESIGN_SIDEPANEL_MODE_FAVORITES_DETAILS

    const [localProducts, setLocalProducts] = useState(products)
    useEffect(() => {
        // Pick up the updated products list when we toggle
        // to the favorites list. This prevents the item from
        // disappearing immediately when unfavorited
        if (mode === modes.DESIGN_SIDEPANEL_MODE_FAVORITES_BROWSE) {
            setLocalProducts(products)
        }
    }, [mode])
    useEffect(() => {
        // If we're watching the favorites panel, only update
        // the list if we're adding a new item
        if (mode === modes.DESIGN_SIDEPANEL_MODE_FAVORITES_BROWSE && products.length > localProducts.length) {
            setLocalProducts(products)
        }
    }, [products])

    return (
        <div className="MyItemsBrowse">
            {isDetailsVisible && (
                <div className={classNames('detailsWrapper', { isDetailsVisible })}>
                    <ProductDetailsViewContainer />
                </div>
            )}
            <div className={classNames('browseWrapper', { isBrowseVisible: !isDetailsVisible })}>
                <div className="itemSelection">
                    <div className="items">
                        <Products furnituresData={localProducts} columnCount={MY_ITEMS_BROWSE_NUM_COLUMNS} />
                    </div>
                </div>
                <div className="checkOut">
                    <button onClick={addAllToBag}>{t('design.add all to shopping bag')}</button>
                </div>
            </div>
        </div>
    )
}

FavoritesBrowseView.propTypes = {
    products: productsDataType.isRequired,
    mode: string.isRequired,
    addAllToBag: func.isRequired,
}

export default FavoritesBrowseView
